import { IncotermsTypeEnum } from '@/types/graphql/schemaTypes';
import { i18n } from '@/plugins/i18n';

const incoterms: any[] = [];
for (const term of Object.keys(IncotermsTypeEnum)) {
  incoterms.push({ value: term, label: replaceUnderscore(term) });
}

function replaceUnderscore(s: string) {
  const words = s.match(/[A-Za-z]*/g) || [];
  return words.join(' ');
}

export function createIncoterms(): any {
  return [{
    label: null,
    options: [
      { value: null, label: i18n.t('incoterms.any') as string },
      { value: IncotermsTypeEnum.FOB, label: 'FOB' },
      { value: IncotermsTypeEnum.CIF, label: 'CIF' },
      { value: IncotermsTypeEnum.CFR, label: 'CFR' }
    ]
  }, {
    label: i18n.t('incoterms.other') as string,
    options: [
      { value: IncotermsTypeEnum.EXW, label: 'EXW' },
      { value: IncotermsTypeEnum.FCA, label: 'FCA' },
      { value: IncotermsTypeEnum.FAS, label: 'FAS' },
      { value: IncotermsTypeEnum.CPT, label: 'CPT' },
      { value: IncotermsTypeEnum.CIP, label: 'CIP' },
      { value: IncotermsTypeEnum.DAT, label: 'DAT' },
      { value: IncotermsTypeEnum.DAP, label: 'DAP' },
      { value: IncotermsTypeEnum.DDP, label: 'DDP' },
      { value: IncotermsTypeEnum.DPU, label: 'DPU' }
    ]
  }];
}

export default incoterms;
